module.exports = __webpack_public_path__ + "img/globe.ff6802f.svg";